import '../styles/globals.css'
import { Geist_Mono, Outfit } from 'next/font/google'
import { Analytics } from '@vercel/analytics/next'

const outfit = Outfit({
  subsets: ['latin'],
  variable: '--font-outfit',
  weight: ['400', '500', '600', '700', '800', '900'],
})

const geistMono = Geist_Mono({
  subsets: ['latin'],
  variable: '--font-geist-mono',
})

function MyApp({ Component, pageProps }) {
  return (
    <div className={`${outfit.variable} ${geistMono.variable} font-sans`}>
      <Component {...pageProps} />
      <Analytics />
    </div>
  )
}

export default MyApp
